module.exports = __webpack_public_path__ + "y.no1.bbcd7d65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/y.no1.jpg
// module id = jRbH
// module chunks = 0